import cn from "classnames";
import { SliderProgressProps } from "./types";
import styles from "./styles.scss";

export const SliderProgress = ({
  size,
  name = "slider-progress",
  activeIndex,
  onChange,
  className,
}: SliderProgressProps) => {
  const handleRadioChange = (index: number) => {
    onChange(index);
  };

  return (
    <div className={cn(styles.root, className)}>
      <fieldset name={name}>
        {Array.from({ length: size }, (_, index) => (
          <input
            value={`${name}-${index}`}
            name={`${name}-radio`}
            checked={activeIndex === index}
            onChange={() => handleRadioChange(index)}
            type="radio"
          />
        ))}
      </fieldset>
    </div>
  );
};
